<template>
  <div class="wg-datastrip">
    <span
      v-if="freshness && freshness.dataThru"
      class="wg-datainfo"
      title="Google shares its numbers with a couple days' delay, so the newest day or two isn't in yet."
    >
      Showing Google's last {{ windowDays }} days, up to <b>{{ fmtThru }}</b> · checked {{ checkedLabel }}
    </span>
    <button
      v-if="canCheck"
      class="wg-pullbtn"
      :disabled="checking"
      :title="`Ask Google for the last ${windowDays} days of data (your report is ${frequency}) and compare it to the ${periodWord} before. Only this page updates; reports we already emailed you never change.`"
      @click="$emit('check')"
    >
      <i class="material-icons ico" :class="{ spin: checking }">refresh</i>
      {{ checking ? 'Checking…' : 'Check for new data' }}
    </button>
  </div>
</template>

<script>
/**
 * Data-control strip (design_updated3 DataStrip): answers "how fresh is
 * this?" and pulls Search Console data on demand.
 */
import moment from 'moment'

export default {
  name: 'WinsDataStrip',
  props: {
    /** { windowDays, dataThru, checkedAt } from the report payload. */
    freshness: {
      type: Object,
      default: null,
    },
    frequency: {
      type: String,
      default: 'quarterly',
    },
    checking: {
      type: Boolean,
      default: false,
    },
    /** The on-demand pull is a campaign-manager (admin mode) tool. */
    canCheck: {
      type: Boolean,
      default: false,
    },
    /** True right after a manual check: caption reads "just now". */
    justChecked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    windowDays () {
      return (this.freshness && this.freshness.windowDays) ||
        (this.frequency === 'monthly' ? 30 : 90)
    },
    periodWord () {
      return this.frequency === 'monthly' ? 'month' : 'quarter'
    },
    fmtThru () {
      return moment(this.freshness.dataThru).format('MMM D')
    },
    checkedLabel () {
      if (this.justChecked) return 'just now'
      const at = this.freshness && this.freshness.checkedAt
      return at ? moment.utc(at).local().format('MMM D, h:mm A') : '–'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../Settings/wg-tokens.scss';

.wg-datastrip {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wg-datainfo {
  font-size: 0.8rem;
  color: $pop-ink-muted;
  margin-left: 2px;

  b {
    color: $pop-teal;
  }
}

.wg-pullbtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  color: $pop-teal;
  background: none;
  border: 1px solid $wg-panel-line;
  border-radius: 30px;
  padding: 5px 13px;
  cursor: pointer;
  transition: all 0.12s;

  .ico {
    font-size: 15px;
  }

  .spin {
    animation: wgspin 0.8s linear infinite;
  }

  &:hover {
    border-color: $pop-teal;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}

@keyframes wgspin {
  to {
    transform: rotate(360deg);
  }
}
</style>
